import React from 'react';
import './ListState.css';

export function LoadingList({ message = 'Memuat data...' }) {
  return (
    <div className="list-state loading-state" role="status" aria-live="polite">
      <div className="list-state-spinner" />
      <p>{message}</p>
    </div>
  );
}

export function EmptyList({
  icon = '📭',
  title = 'Belum ada data',
  message = '',
  action = null,
}) {
  return (
    <div className="list-state empty-state">
      <div className="list-state-icon">{icon}</div>
      <h3>{title}</h3>
      {message ? <p>{message}</p> : null}
      {action}
    </div>
  );
}

export function ErrorList({ title = 'Gagal memuat data', message, onRetry }) {
  return (
    <div className="list-state error-state">
      <div className="list-state-icon">⚠️</div>
      <h3>{title}</h3>
      {message ? <p>{message}</p> : null}
      {onRetry ? (
        <button type="button" className="list-state-retry" onClick={onRetry}>
          Coba lagi
        </button>
      ) : null}
    </div>
  );
}

export function SkeletonGrid({ count = 6, label = 'Memuat data...' }) {
  return (
    <div className="skeleton-grid" role="status" aria-live="polite" aria-label={label}>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="skeleton-card">
          <div className="skeleton-block skeleton-header" />
          <div className="skeleton-block skeleton-line" />
          <div className="skeleton-block skeleton-line short" />
          <div className="skeleton-block skeleton-media" />
        </div>
      ))}
    </div>
  );
}

/** Wrapper seragam untuk list views: loading → error → empty → children */
export function ListState({
  loading,
  error,
  empty,
  emptyProps,
  onRetry,
  loadingVariant = 'spinner',
  children,
}) {
  if (loading) {
    if (loadingVariant === 'skeleton') {
      return (
        <SkeletonGrid
          count={emptyProps?.skeletonCount ?? 6}
          label={emptyProps?.loadingMessage || 'Memuat data...'}
        />
      );
    }
    return <LoadingList message={emptyProps?.loadingMessage} />;
  }
  if (error) return <ErrorList message={error} onRetry={onRetry} />;
  if (empty) return <EmptyList {...emptyProps} />;
  return children;
}
